export const BATCH_PROCESSING = {
  // Core batch sizes for optimization
  PRODUCT_FETCH_BATCH_SIZE: 100,
  CASE_PACK_CREATION_BATCH_SIZE: 100,
  PACKAGE_REGISTRATION_BATCH_SIZE: 100,
  REDUX_ACTION_BATCH_SIZE: 100,

  // Processing limits to prevent UI blocking
  MAX_CONCURRENT_OPERATIONS: 5, // Maximum concurrent async operations
  PROCESSING_CHUNK_SIZE: 200, // Chunk size for large array processing

  BULK_PROCESSING_THRESHOLD: 10,
} as const;

// Helper functions for chunking and batching
export const chunkArray = <T>(array: T[], chunkSize: number = BATCH_PROCESSING.PROCESSING_CHUNK_SIZE): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

export const shouldUseBulkProcessing = (itemCount: number): boolean => {
  return itemCount >= BATCH_PROCESSING.BULK_PROCESSING_THRESHOLD;
};
